export const getHost = url => new URL(url).hostname;

export default {
    getHost,
};
